import { useState, useEffect } from "react";
import React from "react";
import { NavLink } from "react-router-dom";
import { DeliveryExpressIcon, SabadiTextIcon } from "../kits/Icons/Icons.tsx";
import colorsSchema from "../../assets/kits/colors";
import "./ShopItem.scss";
import { addCommas } from "@persian-tools/persian-tools";
import { pathMaker } from "../../utilities/helperFunctions";
import defaultCoverProduct from "../../assets/images/defaultCover/defaultCoverShop.jpg";
import Image from "../common/Image.tsx";
export default function ShopItem({
  shopId,
  shopName,
  shopImageCover,
  shopImageInfo,
  shipping_cost,
  start_hour,
  start_min,
  finish_hour,
  finish_min,
  latShop,
  langShop,
  radiusShop,
  defaultAddress,
  main_status,
  updater,
  updateAddress,
  inventory,
}) {
  console.log("shopImageCover", shopImageCover);
  const [loadImg, setLoadImg] = useState(true);
  let nowHour = new Date().getHours();
  let nowMin = new Date().getMinutes();
  const [shopStatus, setShopStatus] = useState({ title: "" });
  useEffect(() => {
    checkStatusShop();
  }, [updater, updateAddress]);
  function checkStatusShop() {
    let isValid = true;
    let x = Math.pow(defaultAddress[0]?.lat - latShop, 2);
    let y = Math.pow(defaultAddress[0]?.lang - langShop, 2);
    // accept
    if (main_status != "0" || inventory == "0") {
      setShopStatus((prev) => {
        return { ...prev, title: "عدم پذیرش سفارش" };
      });
      isValid = false;
    }
    // location
    // else if (defaultAddress.length > 0) {
    else if (Math.sqrt(x + y) < parseFloat(radiusShop)) {
      setShopStatus((prev) => {
        return { ...prev, title: "فروشگاه خارج از محدوده است." };
      });
      isValid = false;
    }
    // else {
    //   setShopStatus(prev => {
    //     return { ...prev, title: "" };
    //   });
    //   isValid = true;
    // }
    // console.log("location");
    // }

    // check Time
    // else if (start_hour != "" || finish_hour != "") {
    // console.log("hour", nowHour, " ", nowMin);
    else if (start_hour != "" || finish_hour != "") {
      if (
        nowHour < start_hour ||
        nowHour > finish_hour ||
        (nowHour == start_hour && nowMin < start_min) ||
        (nowHour == finish_hour && nowMin > finish_min)
      ) {
        setShopStatus((prev) => {
          return {
            ...prev,
            title: "فروشگاه بسته است.",
          };
        });
        isValid = false;
        // }
      }
    } else {
      setShopStatus((prev) => {
        return { ...prev, title: "" };
      });
      isValid = true;
    }

    return isValid;
  }

  return (
    <>
      <NavLink
        to={`/shop/${shopId}`}
        style={{
          textDecoration: "none",
          color: colorsSchema.foreground_background_he,
        }}
      >
        <div
          className="pd-x-20 mr-b-20 w-100 shopStyles"
          style={{ cursor: "pointer" }}
        >
          <div
            className="position-relative"
            style={{ width: "100%", height: "189px" }}
          >
            <div style={{ width: "100%", height: "189px" }}>
              <Image
                src={pathMaker(shopImageCover)}
                style={{ width: "100%", height: "189px", borderRadius: 6 }}
                placeholderSrc={defaultCoverProduct}
              />
            </div>
            {shopStatus.title != "" && (
              <div className="position-absolute d-flex justify-content-center align-items-center shop-disable">
                <h6 className="text-white title-h4-m">{shopStatus.title}</h6>
              </div>
            )}
          </div>

          <div className="d-flex justify-content-between align-items-center mr-t-8  ">
            <h6 className="title-h5-m">{shopName}</h6>
            <div className="d-flex align-items-center delivery pd-x-4 pd-y-4">
              <DeliveryExpressIcon />

              <h6 className="desc-l pd-r-6">
                {shipping_cost == "0"
                  ? "رایگان"
                  : `${addCommas(shipping_cost)} تومان`}
              </h6>
            </div>
          </div>
        </div>
      </NavLink>
    </>
  );
}
